
import { Options, Vue } from 'vue-class-component';
import store from '@/store/_index';

import AuthForm from '@/components/form/Auth.vue';
import Sidebar from '@/components/Sidebar.vue';
import { ServiceManager } from '@/service/ServiceManager';
import { StoreService } from '@/service/StoreService';

@Options({
  props: {},
  components: {
    AuthForm,
    Sidebar
  }
})
export default class Admin extends Vue {

  private readonly storeService: StoreService = ServiceManager.get(StoreService.factoryName) as StoreService;

  public get userStore() {
    return this.storeService.user;
  }

  get minified(): boolean {
    return store.state.minified as boolean;
  }

  get authenticated(): boolean {
    return this.userStore.authenticated() && !this.userStore.old();
  }

}
